import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { vetVisitReportService } from '../services/apiServices';

const KEYS = {
  all: ['vet-visit-reports'] as const,
  list: (params?: Record<string, any>) => [...KEYS.all, 'list', params] as const,
};

export const useVetVisitReports = (params?: Record<string, any>) =>
  useQuery({
    queryKey: KEYS.list(params),
    queryFn: () => vetVisitReportService.getAll(params),
  });

export const useCreateVetVisitReport = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => vetVisitReportService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
};

export const useUpdateVetVisitReport = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) => vetVisitReportService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
};

export const useDeleteVetVisitReport = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => vetVisitReportService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
};
